interface Props {
  score: number;
}

export const CfsResultLevel = ({ score }: Props) => {
  const styles = {
    padding: '4px 8px',
    fontSize: 16,
    fontWeight: 600,
    borderRadius: 12,
    borderWidth: 1,
    width: 'fit-content',
  };

  const render = () => {
    switch (true) {
      case score <= 5:
        return (
          <div
            style={{
              ...styles,
              color: '#389E0D',
              backgroundColor: '#EDFCDE',
              borderColor: '#95DE64',
            }}
          >
            Fit/Mild
          </div>
        );

      case score <= 6:
        return (
          <div
            style={{
              ...styles,
              color: '#FD8A24',
              backgroundColor: '#FFF4E3',
              borderColor: '#FFD59E',
            }}
          >
            Moderate
          </div>
        );

      default:
        return (
          <div
            style={{
              ...styles,
              color: '#FF4D4F',
              backgroundColor: '#FFF1F0',
              borderColor: '#FFA39E',
            }}
          >
            Severe
          </div>
        );
    }
  };

  return <div style={{ flex: 1 }}>{render()}</div>;
};
